<template>
	<section class="blockquote container container--a">
		<div class="html-content">
			<blockquote :author="data.author">
				<p v-html="data.description"></p>
				<em v-html="data.author" v-if="data.author"></em>
			</blockquote>
		</div>
	</section>
</template>

<script>
export default {
	name: 'blockqoute',
	props: ['data'],
	computed: {},
	components: {},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
.blockquote {
	blockquote {
		margin-left: 0;
		margin-right: 0;
	}
}
</style>
